import { openWorkflowActionPanel } from "components/WorkflowActionPanel";
/**
 * Workflow Workflow with selected itemUri
 *
 * @param {{ itemUri: string }} { itemUri to start Workflow with }
 */

class wf_info {
    execute = async (contextProps) => {
        await openWorkflowActionPanel({ contextProps });
        return true;
    };
}

export default wf_info;
